import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import {ConfigService, PersonalOfferStorageService} from '@nuskin/ns-util';

const PersonalOfferService = function() {
    let initialized = false;
    let currentStep = 1;

    async function init() {
        if (!initialized) {
            let config = ConfigService.getMarketConfig();
            let configTest = {
                apiKey: "AIzaSyDqxHBk_XzYormp9s3pXw9tOKXzJdODWIk",
                authDomain: "testpitch-f0a71.firebaseapp.com",
                databaseURL: "https://testpitch-f0a71.firebaseio.com",
                storageBucket: "testpitch-f0a71.appspot.com"
            };
            let configProd = {
                apiKey: "AIzaSyBrHFBKi6OTY_ygW7_Zt9Qf8vpBYjZQRc4",
                authDomain: "pitch-f99af.firebaseapp.com",
                databaseURL: "https://pitch-f99af.firebaseio.com",
                storageBucket: "pitch-f99af.appspot.com"
            };

            if (config.hasOwnProperty("siteUrl") && config.siteUrl.indexOf("www") !== -1) {
                if (firebase.apps.length === 0) {
                    firebase.initializeApp(configProd);
                }
            } else {
                if (firebase.apps.length === 0) {
                    firebase.initializeApp(configTest);
                }
            }
            await getAnonFirebaseConn()
            initialized = true;
        }
    }
    
    async function getAnonFirebaseConn () {
        let config = ConfigService.getMarketConfig();
        let baseDomain = config.hasOwnProperty("siteUrl") && config.siteUrl.indexOf("www") !== -1 ? "https://www.nuskin.com" : "https://test.nuskin.com";
        let beUrl = `${baseDomain}/simpleBe/api/v2/firebase/token/anonymous`;

        let headers = {
            "client_id": config.checkout.clientId,
            "client_secret": config.checkout.clientSecret
        };
        let params = {
            headers,
            credentials: "omit"
        };
        let tokenData = await fetch(beUrl, params).then(transformFetchResponse);
        
        await firebase.auth().signInWithCustomToken(tokenData.Token.token);
        await firebase.auth().signInAnonymously();
    }

    async function transformFetchResponse (response) {
        let json = await response.json();
        if (response.ok) return json;
        throw json;
    }

    return {
        getOfferV2: async function(sponsorID, pitchID) {
            let sessionPath = `share/users/${sponsorID}/shareLinks/${pitchID}`
            let data = await firebase.database().ref(sessionPath).once('value')
                .then(snapshot => snapshot.val())
            return data
        },
        callProduct: async function(sponsorID, pitchID) {
            await init();
            // v1
            if (currentStep === 1) {
                let localOffer = PersonalOfferStorageService.getPersonalOffer()
                if(localOffer && localOffer.event && !localOffer.event.product) {
                    // eslint-disable-next-line
                    firebase.database().ref("storefront/userPitches/" + sponsorID + "/" + pitchID + "/event").update({"product":new Date().getTime(), "step" : 1});
                }
                currentStep = 1;
            }

            // v2
            let status = 'product_added'
            let sessionData = localStorage.getItem('personalOffer_v2') ? JSON.parse(localStorage.getItem('personalOffer_v2')) : null
            let sessionID = sessionData ? sessionData.sessionId : null
            let v2Offer = await PersonalOfferService.getOfferV2(sponsorID, pitchID)
            // if current session and new status
            let currentSessionAndNewStatus = v2Offer.sessions &&
                v2Offer.sessions[sessionID] &&
                v2Offer.sessions[sessionID].status_history &&
                !v2Offer.sessions[sessionID].status_history[status];

            if(sessionID && currentSessionAndNewStatus) {
                let sessionPath = `share/users/${sponsorID}/shareLinks/${pitchID}/sessions/${sessionID}/`
                firebase.database().ref(sessionPath+'status').set(status);
                firebase.database().ref(sessionPath+'status_history/'+status).set(new Date().toUTCString());
            }
        },
        callShipping: async function(sponsorID, pitchID) {
            await init();
            if (currentStep < 2) {
                // eslint-disable-next-line
                firebase.database().ref("storefront/userPitches/" + sponsorID + "/" + pitchID + "/event").update({"shipping":new Date().getTime(), "step" : 2});
                currentStep = 2;
            }
        },
        callDelivery: async function(sponsorID, pitchID) {
            await init();
            if (currentStep < 3) {
                // eslint-disable-next-line
                firebase.database().ref("storefront/userPitches/" + sponsorID + "/" + pitchID + "/event").update({"delivery":new Date().getTime(), "step" : 3});
                currentStep = 3;
            }
        },
        callPayment: async function(sponsorID, pitchID) {
            await init();
            if (currentStep < 4) {
                // eslint-disable-next-line
                firebase.database().ref("storefront/userPitches/" + sponsorID + "/" + pitchID + "/event").update({"payment":new Date().getTime(), "step" : 4});
                currentStep = 4;
            }
        },
        callReview: async function(sponsorID, pitchID) {
            await init();
            if (currentStep < 5) {
                // eslint-disable-next-line
                firebase.database().ref("storefront/userPitches/" + sponsorID + "/" + pitchID + "/event").update({"review":new Date().getTime(), "step" : 5});
                currentStep = 5;
            }
        },
        callComplete: async function(sponsorID, pitchID) {
            await init();
            // v1
            if (currentStep < 6) {
                // eslint-disable-next-line
                firebase.database().ref("storefront/userPitches/" + sponsorID + "/" + pitchID + "/event").update({"complete":new Date().getTime(), "step" : 6});
                currentStep = 6;
            }
            // v2
            let status = 'purchased'
            let sessionData = localStorage.getItem('personalOffer_v2') ? JSON.parse(localStorage.getItem('personalOffer_v2')) : null
            let sessionID = sessionData ? sessionData.sessionId : null
            let v2Offer = await PersonalOfferService.getOfferV2(sponsorID, pitchID);
            // if current session and new status
            let currentSessionAndNewStatus = v2Offer.sessions &&
                v2Offer.sessions[sessionID] &&
                v2Offer.sessions[sessionID].status_history &&
                !v2Offer.sessions[sessionID].status_history[status];

            if(sessionID && currentSessionAndNewStatus) {
                let sessionPath = `share/users/${sponsorID}/shareLinks/${pitchID}/sessions/${sessionID}/`
                firebase.database().ref(sessionPath+'status').set(status);
                firebase.database().ref(sessionPath+'status_history/'+status).set(new Date().toUTCString());
                localStorage.removeItem('personalOffer_v2')
            }
        },
        callVeraPurchase: async function (sponsorID) {
            await init();
            try {
                const status = 'purchased'
                const session = JSON.parse(localStorage.getItem('skinConsult_session') || {})
                let sessionID = session.sessionId
                let linkID = session.linkID
                if(sessionID && linkID) {
                    let sessionPath = `/share/users/${sponsorID}/shareLinks/${linkID}/sessions/${sessionID}`
                    // TODO: sessionPath, data?
                    // eslint-disable-next-line
                    firebase.database().ref(`${sessionPath}/status`).set(status);
                    // eslint-disable-next-line
                    firebase.database().ref(`${sessionPath}/status_history/${status}`).set(new Date().toUTCString());
                }
            } catch (err) {
                console.log(err)
                console.log('Failed updating VERA status')
            }
        },
        // v2 - sets new session and updates status to 'viewed'
        callViewed: async function(sponsorID, pitchID, v1Data) {
            await init();
            let status = 'viewed'
            let pitchPath = `share/users/${sponsorID}/shareLinks/${pitchID}`
            let sessionPath = `${pitchPath}/sessions`

            if(v1Data) {
                await firebase.database().ref(pitchPath).set(v1Data)
            }
            return await firebase.database().ref(sessionPath).push({
                status,
                status_history: {
                    [status]: new Date().toUTCString()
                }
            }).then(async snapshot => {
                let sessionID = snapshot.key
                await firebase.database().ref(`${sessionPath}/${sessionID}/id`).set(sessionID)
                return sessionID
            })
        },
        sendConfirmationNumber: async function(sponsorID, pitchID, customerName) {
            await init();
            let ordersCompleted = firebase.database().ref('storefront/userPitches/' + sponsorID + '/' + pitchID).child('orders');
            ordersCompleted.transaction(function(name) {
                if (name == null || typeof(name) === 'number') {
                    name = [];
                } else if (typeof(name) === 'string') {
                    let tempName = name;
                    name = [];
                    name.push(tempName);
                }
                name.push(customerName);

                return name;
            });

            let pitchConversions = firebase.database().ref("storefront/userPitches/" + sponsorID + "/" + pitchID).child('conversions');
            pitchConversions.transaction(function(count) {
                return (count || 0) + 1;
            });

            //Increment Pitches converted
            let convertedRef = firebase.database().ref('storefront/users/'+sponsorID).child('pitchesConverted');
            convertedRef.transaction(function (count) {
                return count + 1;
            });
        },
        getCurrentStep: function() {
            return currentStep;
        }
    }
}();

export default PersonalOfferService;
